import axios from 'axios';
import https from 'https';

const agent = new https.Agent({
    rejectUnauthorized: false,
});

/**
 * Buscando do próprio servidor node, pois o servidor mercadomail produção
 * estava dando erro de CORS *,*
 */
const tracking = axios.create({
    baseURL: 'http://quandochega.com.br',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    httpsAgent: agent,
});

export default tracking;
